import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PriceMappingSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PriceMappingSVG;
